export const getColumnSize = (acc, column) => `${acc}  ${column.columnSize}`;
